import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { DialogService } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { InfoDialogComponent, InfoDialogDataModel } from '../info-dialog/info-dialog.component';

export enum LabeledValueInlineContainerStyleEnum {
  Default = '',
  Success = 'success',
  Danger = 'danger',
}

@Component({
  selector: 'cui-labeled-value-inline-container',
  imports: [TooltipModule, NgClass, IconComponent],
  templateUrl: './labeled-value-inline-container.component.html',
  styleUrls: ['./labeled-value-inline-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabeledValueInlineContainerComponent {
  @Input() hasBorder = true;
  @Input() showOverflow = false;
  @Input() hideHeader = false;
  @Input() infoModalText: string | undefined;
  @Input() headline: string | undefined;
  @Input() titleStyleClass: string | undefined;
  @Input() contentStyleClass: string | undefined;
  @Input() style: LabeledValueInlineContainerStyleEnum = LabeledValueInlineContainerStyleEnum.Default;

  private readonly dialogService = inject(DialogService);

  protected showInfoModal(): void {
    const data: InfoDialogDataModel = {
      header: this.headline,
      text: this.infoModalText,
    };

    this.dialogService.open(InfoDialogComponent, {
      data,
      closable: false,
      closeOnEscape: true,
      transitionOptions: '0ms',
    });
  }
}
